/* begin general import */
import OverflowMenuHorizontal24 from "@carbon/icons-react/es/overflow-menu--horizontal/24";
import SettingsAdjust16 from "@carbon/icons-react/es/settings--adjust/16";
import TrashCan16 from "@carbon/icons-react/es/trash-can/16";
import { Dropdown, Menu, Spin } from "antd";
import { ColumnProps } from "antd/lib/table";
import { APP_USER_ROUTE } from "config/route-consts";
import { AppUser, AppUserFilter } from "models/AppUser";
import { Organization, OrganizationFilter } from "models/Organization";
import { Sex } from "models/Sex";
import { Status } from "models/Status";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { IdFilter } from "react3l-advanced-filters";
import {
  ActionBarComponent,
  AdvanceEnumFilterMaster,
  AdvanceTreeFilterMaster,
  Button,
  LayoutCell,
  LayoutHeader,
  OneLineText,
  Pagination,
  StandardTable,
  StatusLine,
  TagFilter,
} from "react3l-ui-library";
import InputSearch from "react3l-ui-library/build/components/Input/InputSearch";
import { appUserRepository } from "repositories/app-user-repository";
import { filterService } from "services/page-services/filter-service";
import { importExportService } from "services/page-services/import-export-service";
import { listService } from "services/page-services/list-service";
import { queryStringService } from "services/page-services/query-string-service";
import {
  getAntOrderType,
  tableService,
} from "services/page-services/table-service";
import nameof from "ts-nameof.macro";
import AppUserAdvanceFilter from "./AppUserAdvanceFilter";
import AppUserChangePassView, {
  useAppUserChangePassHook,
} from "./AppUserChangePassHook";
import AppUserRoleMappingView, {
  useAppUserRoleMappingHook,
} from "./AppUserRoleMappingHook";
import { authorizationService } from "services/common-services/authorization-service";
import { API_APP_USER_PREFIX } from "config/api-consts";
/* end individual import */

function AppUserMaster() {
  const [translate] = useTranslation();
  const [modelFilter, dispatch] = queryStringService.useQueryString(
    AppUserFilter,
    { skip: 0, take: 10 }
  );
  const history = useHistory();
  const idChangePassword = Number(
    history.location?.search?.replace("?idChangePassword=", "")
  );

  const { validAction } = authorizationService.useAuthorizedAction(
    APP_USER_ROUTE.split("/")[APP_USER_ROUTE.split("/").length - 1],
    API_APP_USER_PREFIX
  );

  const [visible, setVisible] = React.useState<boolean>(false);

  // handleListExport, handleExportTemplateList,
  const { loading } = importExportService.useExport();

  const {
    value: filter,
    handleChangeSelectFilter,
    handleChangeTreeFilter,
    handleChangeAllFilter,
    handleChangeInputSearch,
  } = filterService.useFilter(modelFilter, dispatch);

  const { list, count, loadingList, handleResetList } = listService.useList(
    appUserRepository.list,
    appUserRepository.count,
    filter,
    dispatch
  );
  // const {
  //   handleImportList,
  //   handleClick,
  //   ref: importButtonRef,
  // } = importExportService.useImport(handleResetList);

  const { handleTableChange, handlePagination } = tableService.useTable(
    filter,
    handleChangeAllFilter
  );

  // handleAction,
  const {
    handleBulkAction,
    canBulkAction,
    selectedRowKeys,
    setSelectedRowKeys,
  } = listService.useRowSelection(
    appUserRepository.delete,
    appUserRepository.bulkDelete,
    null,
    null,
    null,
    handleResetList
  );

  // const { handleGoCreate, handleGoDetail, handleDeleteItem } =
  //   masterService.useMasterAction(APP_USER_ROUTE, handleAction);

  const routeView = APP_USER_ROUTE;

  const baseRoute = React.useMemo(() => {
    let listPath = routeView.split("/");
    const baseRoute = "/" + listPath[listPath.length - 1];
    return baseRoute;
  }, [routeView]);

  const { visibleRole, appUser, handleCloseRoleView, handleSaveRole } =
    useAppUserRoleMappingHook(() => handleChangeAllFilter);
  const {
    pass,
    cfPass,
    errorVisible,
    errorName,
    visibleChangePass,
    handleChangePass,
    handleChangeConfirmPass,
    handleCloseChangePassView,
    handleSaveNewPass,
    handleOpenchangePassView,
  } = useAppUserChangePassHook(() => handleChangeAllFilter);

  const ref = React.useRef<boolean>(true);
  React.useEffect(() => {
    if (ref.current && idChangePassword) {
      handleOpenchangePassView(idChangePassword);
      ref.current = false;
    }
  }, [handleOpenchangePassView, idChangePassword]);

  // const handleChageActive = React.useCallback(
  //   (currentItem) => {
  //     Modal.confirm({
  //       title:
  //         currentItem.statusId === 1
  //           ? translate("appUsers.inactive.title")
  //           : translate("appUsers.active.title"),
  //       content:
  //         currentItem.statusId === 1
  //           ? translate("appUsers.inactive.content")
  //           : translate("appUsers.active.content"),
  //       okType: "danger",
  //       onOk() {
  //         if (currentItem.statusId === 1) {
  //           currentItem.statusId = 0;
  //         } else {
  //           currentItem.statusId = 1;
  //         }

  //         appUserRepository.update(currentItem).subscribe(() => {
  //           handleChangeAllFilter(filter);
  //         });
  //       },
  //     });
  //   },
  //   [filter, handleChangeAllFilter, translate]
  // );

  const handleGoPermission = React.useCallback(
    (id: any) => {
      history.push(`${routeView}${baseRoute}-permission?id=${id}`);
    },
    [routeView, baseRoute, history]
  );

  const menuAction = React.useCallback(
    (id: number, appUser: AppUser) => (
      <Menu>
        {validAction("updateResource") && (
          <Menu.Item key="1">
            <div
              className="ant-action-menu text-center "
              onClick={() => handleGoPermission(id)}
            >
              {translate("general.actions.addPermission")}
            </div>
          </Menu.Item>
        )}

        {/* {validAction("update") && (
          <Menu.Item key="2">
            <div
              className="ant-action-menu text-center"
              onClick={() => handleChageActive(appUser)}
            >
              {appUser.statusId === 1
                ? translate("appUsers.inactive.title")
                : translate("appUsers.active.title")}
            </div>
          </Menu.Item>
        )}
        {validAction("changePassword") && (
          <Menu.Item key="3">
            <div
              className="ant-action-menu text-center"
              onClick={() => handleOpenchangePassView(id)}
            >
              {translate("general.actions.changePass")}
            </div>
          </Menu.Item>
        )} */}
        {/* {validAction("update") && (
          <Menu.Item key="4">
            <div
              className="ant-action-menu text-center"
              onClick={handleGoDetail(id)}
            >
              {translate("general.actions.edit")}
            </div>
          </Menu.Item>
        )}

        {!appUser.used && validAction("delete") && (
          <Menu.Item key="5">
            <div
              className="ant-action-menu text-center"
              onClick={handleDeleteItem(appUser)}
            >
              {translate("general.actions.delete")}
            </div>
          </Menu.Item>
        )} */}
      </Menu>
    ),
    [
      // handleChageActive,
      handleGoPermission,
      // handleOpenchangePassView,
      translate,
      validAction,
    ]
  );

  const columns: ColumnProps<AppUser>[] = useMemo(
    () => [
      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "username"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.username")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].username),
        dataIndex: nameof(list[0].username),
        sorter: true,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].username)
        ),
        //width: 120,
        ellipsis: true,
        render(...params: [string, AppUser, number]) {
          return (
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={params[0]} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "displayName"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.displayName")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].displayName),
        dataIndex: nameof(list[0].displayName),
        sorter: true,
        //width: 120,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].displayName)
        ),
        ellipsis: true,
        render(...params: [string, AppUser, number]) {
          return (
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={params[0]} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "email"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.email")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].email),
        dataIndex: nameof(list[0].email),
        sorter: true,
        ellipsis: true,
        //width: 120,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].email)
        ),
        render(...params: [string, AppUser, number]) {
          return (
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={params[0]} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "phone"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.phone")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].phone),
        dataIndex: nameof(list[0].phone),
        sorter: true,
        //width: 120,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].phone)
        ),
        ellipsis: true,
        render(...params: [string, AppUser, number]) {
          return (
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={params[0]} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "organization"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.organization")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].organization),
        dataIndex: nameof(list[0].organization),
        sorter: true,
        //width: 120,
        ellipsis: true,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].organization)
        ),
        render(organization: Organization) {
          return (
            //fill the render field after generate code;
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={organization?.name} countCharacters={24} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "businessArea"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.businessArea")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].businessArea),
        dataIndex: nameof(list[0].businessArea),
        sorter: true,
        //width: 120,
        ellipsis: true,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].businessArea)
        ),
        render(businessArea: Organization) {
          return (
            //fill the render field after generate code;
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={businessArea?.name} countCharacters={24} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "sex"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.sex")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].sex),
        dataIndex: nameof(list[0].sex),
        sorter: true,
        ellipsis: true,
        //width: 120,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].sex)
        ),
        render(sex: Sex) {
          return (
            //fill the render field after generate code;
            <LayoutCell orderType="left" tableSize="sm">
              <OneLineText value={sex?.name} />
            </LayoutCell>
          );
        },
      },

      {
        title: ({ sortColumns }) => {
          const sortedColumn = sortColumns?.find(
            ({ column }) => column.key === "status"
          );
          return (
            <LayoutHeader
              orderType="left"
              title={translate("appUsers.status")}
              sortedColumn={sortedColumn}
              isSorter
            />
          );
        },
        key: nameof(list[0].status),
        dataIndex: nameof(list[0].status),
        sorter: true,
        sortOrder: getAntOrderType<AppUser, AppUserFilter>(
          filter,
          nameof(list[0].status)
        ),
        //width: 120,
        ellipsis: true,
        render(status: Status) {
          return (
            //fill the render field after generate code;
            <LayoutCell orderType="left" tableSize="md">
              <StatusLine value={status?.name} color={status?.color} />
            </LayoutCell>
          );
        },
      },

      {
        key: "action",
        dataIndex: nameof(list[0].id),
        fixed: "right",
        width: 80,
        align: "center",
        render(id: number, appUser: AppUser) {
          return (
            <div className="d-flex justify-content-center button-action-table">
              <Dropdown
                overlay={menuAction(id, appUser)}
                trigger={["click"]}
                placement="bottom"
                arrow
              >
                <OverflowMenuHorizontal24 className="btn-missions-blue" />
              </Dropdown>
            </div>
          );
        },
      },
    ],
    [translate, list, filter, menuAction]
  );

  const handleCancel = React.useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <>
      <Spin spinning={loading}>
        <div className="page-content page-content-dxg" id="page-content-dxg-id">
          <div className="info-component ml-4 mb-3">
            <span>{translate("appUsers.master.header")}</span>
            <span> &gt; </span>
            <span className="info-primary">
              {translate("appUsers.master.subHeader")}
            </span>
          </div>

          <div className="page page-master m-b--xxs">
            <div className="pt-4 pb-1 ml-3">
              <h5 className="font-bold page-title">
                {translate("appUsers.master.title")}
              </h5>
            </div>

            <div className="page-master__content">
              <div className="page-master__tag-filter">
                <TagFilter
                  value={filter}
                  translate={translate}
                  keyTranslate={"appUsers"}
                  handleChangeFilter={handleChangeAllFilter}
                  onClear={() => {
                    return 0;
                  }}
                />
              </div>
              {(!selectedRowKeys || selectedRowKeys?.length === 0) && (
                <div className="page-master__filter-wrapper d-flex align-items-center justify-content-between px-3">
                  <div className="page-master__filter d-flex align-items-center justify-content-start">
                    {validAction("filterListOrganization") && (
                      <div className="">
                        <AdvanceTreeFilterMaster
                          onChange={handleChangeTreeFilter({
                            fieldName: "organization",
                            fieldType: "equal",
                            classFilter: IdFilter,
                          })}
                          maxLengthItem={23}
                          label={translate("appUsers.organization")}
                          placeHolder={translate(
                            "appUsers.placeholder.organization"
                          )}
                          getTreeData={appUserRepository.filterListOrganization}
                          checkStrictly={true}
                          classFilter={OrganizationFilter}
                          render={(item) =>
                            item && item.id
                              ? `${item?.code} - ${item?.name}`
                              : null
                          }
                          searchProperty="search"
                          searchType=""
                          item={filter[nameof(list[0].organizationValue)]}
                        />
                      </div>
                    )}
                    {validAction("filterListSex") && (
                      <div className="">
                        <AdvanceEnumFilterMaster
                          value={filter[nameof(list[0].sexId)]["equal"]}
                          getList={appUserRepository.filterListSex}
                          onChange={handleChangeSelectFilter({
                            fieldName: nameof(list[0].sex),
                            fieldType: "equal",
                            classFilter: IdFilter,
                          })}
                          label={translate("appUsers.sex")}
                        />
                      </div>
                    )}
                    {validAction("filterListStatus") && (
                      <div className="">
                        <AdvanceEnumFilterMaster
                          value={filter[nameof(list[0].statusId)]["equal"]}
                          getList={appUserRepository.filterListStatus}
                          onChange={handleChangeSelectFilter({
                            fieldName: nameof(list[0].status),
                            fieldType: "equal",
                            classFilter: IdFilter,
                          })}
                          label={translate("appUsers.status")}
                        />
                      </div>
                    )}
                  </div>
                  <div className="page-master__filter-action-search d-flex align-items-center">
                    <Button
                      type="icon-only-ghost"
                      icon={<SettingsAdjust16 />}
                      onClick={() => setVisible(true)}
                      className="btn--xl"
                    />
                    <InputSearch
                      value={filter.search}
                      classFilter={AppUserFilter}
                      placeHolder={translate("general.placeholder.search")}
                      onChange={handleChangeInputSearch}
                      animationInput={filter?.search ? false : true}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="page-master__content-table">
              {validAction("bulkDelete") && (
                <ActionBarComponent
                  selectedRowKeys={selectedRowKeys}
                  setSelectedRowKeys={setSelectedRowKeys}
                  translateTitleCancelButton={translate(
                    "general.actions.close"
                  )}
                >
                  <Button
                    icon={<TrashCan16 />}
                    type="ghost-primary"
                    className="btn--lg"
                    disabled={!canBulkAction}
                    onClick={() => handleBulkAction(selectedRowKeys)}
                  >
                    {translate("general.actions.delete")}
                  </Button>
                </ActionBarComponent>
              )}
              <StandardTable
                rowKey={nameof(list[0].id)}
                columns={columns}
                dataSource={list}
                isDragable={true}
                tableSize={"md"}
                onChange={handleTableChange}
                spinning={loadingList}
                scroll={{ x: 1000 }}
              />

              <Pagination
                skip={filter?.skip}
                take={filter?.take}
                total={count}
                onChange={handlePagination}
              />
            </div>
          </div>
        </div>
      </Spin>

      {visible && (
        <AppUserAdvanceFilter
          visible={visible}
          handleClose={handleCancel}
          visibleFooter={true}
          loading={false}
          size={"sm"}
          filter={filter}
          setVisible={setVisible}
          handleChangeAllFilter={handleChangeAllFilter}
        />
      )}
      {visibleRole && (
        <AppUserRoleMappingView
          model={appUser}
          isOpenRoleModel={visibleRole}
          handleCloseRoleModel={handleCloseRoleView}
          onSave={handleSaveRole}
          translate={translate}
        />
      )}
      {visibleChangePass && (
        <AppUserChangePassView
          pass={pass}
          cfPass={cfPass}
          errorVisible={errorVisible}
          errorName={errorName}
          visibleChangePass={visibleChangePass}
          handleChangePass={handleChangePass}
          handleChangeConfirmPass={handleChangeConfirmPass}
          handleCloseChangePassView={handleCloseChangePassView}
          handleSaveNewPass={handleSaveNewPass}
          translate={translate}
        />
      )}
    </>
  );
}
export default AppUserMaster;
